module.exports = __webpack_public_path__ + "static/media/zoom.4b735d86.svg";